import React, { useState } from 'react';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import { ArrowLeft, ArrowRight, ChevronRight } from 'lucide-react';

const roles = [
  {
    id: 1,
    title: "Backend Engineer",
    desc: "Deploy our acclaimed Full-Stack Developers with curated expertise and vetted experience in just 48 hours.",
    skills: [".Net Developer", "Java Developer", "MEAN Developer", "MEARN Developer"],
    theme: "blue",
  },
  {
    id: 2,
    title: "Mobile App Developer",
    desc: "Deploy our acclaimed Full-Stack Developers with curated expertise and vetted experience in just 48 hours.",
    skills: ["iOS Developer", "Android Developer", "Flutter Developer", "React Native"],
    theme: "orange",
  },
  {
    id: 3,
    title: "QA Engineer",
    desc: "Ensure flawless performance with our expert QA engineers who rigorously test your software for bugs and issues.",
    skills: ["Manual Testing", "Automation", "Selenium", "JMeter"],
    theme: "blue",
  },
  {
    id: 4,
    title: "Frontend Developer",
    desc: "Create stunning user interfaces with our skilled frontend developers proficient in modern frameworks.",
    skills: ["React.js", "Vue.js", "Angular", "Next.js"],
    theme: "orange",
  },
];

const ConnectDevelopers = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const [sliderRef, instanceRef] = useKeenSlider({
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
    slides: {
      perView: 1.1,
      spacing: 20,
    },
    breakpoints: {
      '(min-width: 768px)': {
        slides: { perView: 2.1, spacing: 20 },
      },
      '(min-width: 1024px)': {
        slides: { perView: 2.3, spacing: 20 },
      },
    },
  });

  return (
    <section className="w-full pb-12 lg:pb-20 bg-white font-sans overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-[80px]">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
          <h2 className="text-[#0E2A62] text-[20px] font-sora md:text-[30px] font-[600] leading-tight">
            Connect with Skilled Developers for Every Project
          </h2>

          <div className="flex gap-4">
            <button
              onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
              className="w-[32px] h-[32px] rounded-full border border-[#F06115] text-[#F06115] flex items-center justify-center hover:bg-[#F06115] hover:text-white transition-all duration-300 disabled:opacity-50"
            >
              <ArrowLeft size={18} />
            </button>
            <button
              onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
              className="w-[32px] h-[32px] rounded-full border border-[#F06115] text-[#F06115] flex items-center justify-center hover:bg-[#F06115] hover:text-white transition-all duration-300"
            >
              <ArrowRight size={18} />
            </button>
          </div>
        </div>
        <div ref={sliderRef} className="keen-slider py-4">
          {roles.map((role, index) => {
            const isOrange = index % 2 !== 0;
            const buttonClass = isOrange
              ? 'border-[#F06115] text-[#F06115] hover:bg-[#F06115] hover:text-white'
              : 'border-[#F06115] text-[#F06115] hover:bg-[#F06115] hover:text-white';

            return (
              <div key={role.id} className="keen-slider__slide h-auto flex">

                <div className={`w-full bg-[#F8F9FC] p-8 md:p-10 flex flex-col justify-between transition-shadow duration-300 hover:shadow-xl relative group`}>

                  <div>
                    <h3 className="text-[#0E2A62] font-[600] lg:text-[20px] text-[16px] font-sora mb-[16px]">
                      {role.title}
                    </h3>

                    <p className="text-[#49577A] lg:text-[16px] text-[14px] font-[500] font-graphik leading-relaxed mb-8">
                      {role.desc}
                    </p>

                    <div className="flex flex-wrap gap-3 mb-10">
                      {role.skills.map((skill, idx) => (
                        <span
                          key={idx}
                          className="px-3 py-1.5 border border-[#0E2A62] text-[#0E2A62] text-[11px] font-graphik font-[500] rounded-md bg-white uppercase tracking-wide"
                        >
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row items-center gap-6 mt-auto">
                    <button className={`flex items-center justify-between px-6 py-3 w-full sm:w-auto min-w-[160px] border font-semibold transition-all duration-300 group ${buttonClass}`}>
                      Hire Now
                      <ChevronRight size={18} className="transform group-hover:translate-x-1 transition-transform" />
                    </button>

                    <button className="flex items-center underline gap-2 text-[#0F3460] font-semibold text-sm hover:underline group">
                      Ready To Discuss
                      <ChevronRight size={16} className="text-[#F06115] transform group-hover:translate-x-1 transition-transform" />
                    </button>
                  </div>
                  <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#0F3460]"></div>
                  <div className="absolute bottom-0 left-0 h-[4px] bg-[#F06115] w-0 group-hover:w-full transition-all duration-500 ease-in-out z-10"></div>

                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default ConnectDevelopers;